export default function indentJSON(content: string | null): string {
  return JSON.stringify(JSON.parse(content ?? "null"), null, 4);
}
